import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={props.width || 20}
      height={props.height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle
        cx={10}
        cy={10}
        r={10}
        fill={props.bgColor || "#FF2E00"}
        {...props}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.997 8.032l4.035-4.035L16 5.964 11.964 10 16 14.034l-1.967 1.967-4.036-4.035-4.033 4.033-1.967-1.967L8.031 10 3.998 5.966 5.965 4l4.032 4.032z"
        fill={props.color || "#fff"}
      />
    </Svg>
  );
}

export default SvgComponent;
